import BaseViewController from "./base-view-controller";

class MinorMhIntakeCustomViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();

    if (Array.isArray(this.screen.fields)) {
      this.screen.fields.forEach(field => {
        if (field.type === "formRadioButtons") {
          field.options.forEach(option => {
            if (option.selected === "true" || option.selected === true) {
              this.appData.values[field.name] = option.value;
            }
          });
        }
      });
    }
  }
}

export default MinorMhIntakeCustomViewController;
